import Icon from '../generic/Icon';
import * as style from './ProductIcon.module.css';

export default function ProductIcon({ icon }: { icon: string }) {
    return (
        <Icon
            className={`${style.productIcon} ${icon
                .split(' ')
                .map((icon) => style[icon])
                .join(' ')}`}
        />
    );
}
